import { generateURL } from 'utils/helpers';

const services = {
  getNextDepartures: (params) => {
    const url = generateURL('/service/next_departures', params);
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(
          new Error('Failed to get next departure service')
        );
      }
      return response.json();
    });
  },
};

export default services;
